<template>
  <div class="rc-address-design">
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <div class="form-item-address">
        <el-select class="form-select" placeholder="请选择省份" v-model="option" disabled></el-select>
      </div>
      <div class="form-item-address">
        <el-select class="form-select" placeholder="请选择城市" v-model="option" disabled></el-select>
      </div>
      <div class="form-item-address">
        <el-select class="form-select" placeholder="请选择区" v-model="option" disabled></el-select>
      </div>
      <div class="form-item-address">
        <el-input class="form-input" placeholder="请输入详细地址" disabled></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'

export default {
  name: 'rc-address',
  props: ['initComponent', 'value'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent,
      option: ''
    }
  }
}
</script>

<style lang="scss">
 .form-layout .layout-form .list-component-item > div.rc-address-design {
    div.component-content {
      width: 100%;
      padding-left: 0;
      overflow: hidden;
      .form-item-address {
        float: left;
        width: 25%;
      }
    }
    .el-input__inner {
      padding-left: 10px;
    }
    .form-input {
      display: inline-block;
      width: 100%;
    }
    .form-select {
      display: inline-block;
      width: calc(100% - 14px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/address/rc-address.vue